// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _filtroTypeUtilsData = {
  "Olio": {
    "Label": {
      "it": "Olio",
      "de": "Öl",
      "en": "Oil"
    },
    "Icon": "water_drop"
  },
  "Aria": {
    "Label": {
      "it": "Aria",
      "de": "Luft",
      "en": "Air"
    },
    "Icon": "air"
  }
} as const